import { ApolloClient, HttpLink, from } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import { cache } from './graphql';
import { authHeader, clearSession } from './auth/session';

/**
 * Same-origin. Firebase Hosting rewrites `/api` to the Cloud Run service in
 * production and Vite proxies it in development, so the client ships no
 * backend URL — which is what removes the three REACT_APP_BACKEND_URL_*
 * variables and the CORS configuration they needed.
 */
const httpLink = new HttpLink({ uri: '/api' });

const authLink = setContext((_operation, { headers }) => ({
  headers: { ...headers, ...authHeader() },
}));

/**
 * A token that is expired, revoked, or left over from an account that has
 * since been disabled comes back as UNAUTHENTICATED. Holding on to it means
 * every subsequent request fails the same way, so it is discarded here and
 * the route guard sends the user to the login page on the next render.
 */
const sessionLink = onError(({ graphQLErrors }) => {
  const expired = (graphQLErrors ?? []).some(
    (error) => error.extensions?.code === 'UNAUTHENTICATED',
  );
  if (expired) clearSession();
});

export default new ApolloClient({
  link: from([sessionLink, authLink, httpLink]),
  cache,
});
